import Image, { type ImageOptions } from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ContentImageView } from './content-image-view';

type ContentImageOptions = ImageOptions & {
  onEdit: (nodePosition: number, src: string, alt?: string) => unknown;
};

export const ContentImage = Image.extend<ContentImageOptions>({
  addOptions(): ContentImageOptions {
    const defaultOptions = {
      inline: true,
      allowBase64: true,
      HTMLAttributes: {},
    };
    return {
      ...(this.parent == null ? defaultOptions : this.parent()),
      onEdit: () => {},
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ContentImageView);
  },
  draggable: true,
});
